import { RJSFSchema } from '@rjsf/utils';

export const Ip2locationSchema: RJSFSchema = {
    type: "object",
    properties: {
        url: { type: 'string' },
    }
  }